module.exports = __webpack_public_path__ + "img/7_70.e0e0fa86.png";